import axiosInstance from './axios.service';

const authService = {
  login: async credentials => {
    const { data } = await axiosInstance.post('/api/auth/login', credentials);
    return data;
  },

  register: async userData => {
    const { data } = await axiosInstance.post('/api/auth/register', userData);
    return data;
  },

  logout: async () => {
    const { data } = await axiosInstance.post('/api/auth/logout');
    return data;
  },

  forgotPassword: async email => {
    const { data } = await axiosInstance.post('/api/auth/forgot-password', { email });
    return data;
  },

  resetPassword: async (token, newPassword) => {
    const { data } = await axiosInstance.put('/api/auth/reset-password', {
      token,
      password: newPassword,
    });
    return data;
  },

  verifyUser: async token => {
    const { data } = await axiosInstance.put('/api/auth/verify', { token });
    return data;
  },

  refreshToken: async () => {
    const { data } = await axiosInstance.post('/api/auth/refresh-token');
    return data;
  },

  getCurrentUser: async () => {
    const { data } = await axiosInstance.get('/api/auth/me');
    return data;
  },
};

export default authService;
